import PropTypes from "prop-types"
import React, { useState } from "react"

import { connect } from "react-redux"
import { Row, Col, UncontrolledTooltip, Tooltip } from "reactstrap"
import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import megamenuImg from "../../assets/images/megamenu-img.png"

// import images
import github from "../../assets/images/brands/github.png"
import bitbucket from "../../assets/images/brands/bitbucket.png"
import dribbble from "../../assets/images/brands/dribbble.png"
import dropbox from "../../assets/images/brands/dropbox.png"
import mail_chimp from "../../assets/images/brands/mail_chimp.png"
import slack from "../../assets/images/brands/slack.png"
//i18n
import { withTranslation } from "react-i18next"
import ImpersonateModal from "./../../pages/User/modal/ImpersonateModal"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  deleteImpersonateUser as onDeleteImpersonateUser,
} from "../../store/actions"

const Header = props => {
  const dispatch = useDispatch()

  const [search, setsearch] = useState(false)
  const [megaMenu, setmegaMenu] = useState(false)
  const [socialDrp, setsocialDrp] = useState(false)
  const [impersonateModal, setImpersonateModal] = useState(false)
  const { basicSetting } = useSelector(state => state.Layout)
  const { userprofile } = useSelector(state => state.user)
  const [impersonateToolTip, setImpersonateToolTip] = useState(false)
  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  const onClickRemoveImpersonate = arg => {
    //console.log(arg)
    setImpersonateModal(true)
  }

  const handleImpersonateUser = () => {
    if (userprofile && userprofile.ImpersonateUserID) {
      dispatch(onDeleteImpersonateUser(userprofile.ImpersonateUserID))
      setImpersonateModal(false)
    }
  }

  return (
    <React.Fragment>
      {impersonateModal && (
        <ImpersonateModal
          show={impersonateModal}
          text={`You want to remove impersonation for ${userprofile.ImpersonateUserName}?`}
          onSubmitClick={handleImpersonateUser}
          onCloseClick={() => setImpersonateModal(false)}
        />
      )}
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src={
                      basicSetting && basicSetting?.SmallDarkLogoFileName
                        ? `${process.env.REACT_APP_API_ROOT_URL}/_files/Theme/${basicSetting?.SmallDarkLogoFileName}`
                        : process.env.REACT_APP_SMALL_LOGO_DARK
                    }
                    alt=""
                    style={{
                      maxWidth: "50px",
                    }}
                  />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src={
                      basicSetting && basicSetting?.SmallLightFileName
                        ? `${process.env.REACT_APP_API_ROOT_URL}/_files/Theme/${basicSetting?.SmallLightFileName}`
                        : process.env.REACT_APP_SMALL_LOGO_LIGHT
                    }
                    alt=""
                    style={{
                      maxWidth: "50px",
                    }}
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            <form className="app-search d-none">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={props.t("Search") + "..."}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search)
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div
              className="d-flex align-items-center"
              hidden={!userprofile.Impersonate}
            >
              {userprofile.Impersonate && (
                <>
                  <div
                    className="alert alert-primary fade show d-none d-md-inline-block mb-0"
                    role="alert"
                  >
                    You are impersonating to {userprofile.ImpersonateUserName}
                  </div>

                  <button
                    type="button"
                    className="btn btn-secondary d-md-none"
                    id="btnImpersonate"
                  >
                    <i className="mdi mdi-drama-masks fs-3"></i>
                  </button>
                  <Tooltip
                    placement="bottom"
                    isOpen={impersonateToolTip}
                    target="btnImpersonate"
                    toggle={() => {
                      setImpersonateToolTip(!impersonateToolTip)
                    }}
                  >
                    You are impersonating to {userprofile.ImpersonateUserName}
                  </Tooltip>
                  <button
                    type="button"
                    onClick={() => {
                      onClickRemoveImpersonate(userprofile)
                    }}
                    className="btn header-item noti-icon"
                  >
                    <i
                      className="bx bx-revision"
                      id="removeimpersonatetooltip"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="removeimpersonatetooltip"
                    >
                      Remove Impersonate
                    </UncontrolledTooltip>
                  </button>
                </>
              )}
            </div>
            {/* <LanguageDropdown /> */}
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>

            {/* <NotificationDropdown /> */}
            <ProfileMenu />

            {/* <div
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar)
              }}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
